'use strict';

/**
 * tooltip decorator implementation for the image-teaser module.
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.ImageTeaser.Tooltip = T.createDecorator({

	_selectors: {
		tooltipTrigger: '[data-js-m-image-teaser__tooltip]'
	},

	_stateClasses: {
		open: 'state-open'
	},

	_eventNames: {
		close: 'popover-close',
		closeCallback: 'popover-close-callback',
		open: 'popover-open'
	},

	_libraryUrl: '/assets/vendor/popper.min.js',

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$tooltipTriggers = this.$ctx.find(this._selectors.tooltipTrigger);

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));
		this._events.on(this._eventNames.closeCallback, this.onPopoverCloseCallback.bind(this));

		this._parent.start(resolve);
	},
	sync: function sync() {
		if (typeof Popper !== 'undefined') {
			this.initializeTooltips();
		} else {
			this.loadLibrary();
		}
	},


	/**
  * initialize the tooltips
  *
  * @returns {void}
  */
	initializeTooltips: function initializeTooltips() {
		this.$tooltipTriggers.on('click', this.onTooltipTriggerClick.bind(this));
	},


	/**
  * Load the tooltip library
  *
  * @returns {void}
  */
	loadLibrary: function loadLibrary() {
		$.fn.loadScript(this._libraryUrl, this.initializeTooltips.bind(this));
	},


	/**
  * Event when the user clicks on a tooltip
  *
  * @param {Event} ev The click event
  * @returns {void}
  */
	onTooltipTriggerClick: function onTooltipTriggerClick(ev) {
		ev.preventDefault();

		var $currentTooltip = $(ev.currentTarget);

		if (!$currentTooltip.hasClass(this._stateClasses.open)) {

			var index = $currentTooltip.data('tooltip-index');
			var contentHtml = $.trim(this.$ctx.find('[data-js-m-image-teaser__tooltip-' + index + '-content]').html());

			$currentTooltip.addClass(this._stateClasses.open);

			this._events.emit(this._eventNames.open, {
				$trigger: $currentTooltip,
				content: contentHtml
			});
		}
	},


	/**
  * Event when the a popover was closed
  *
  * @param {Object} eventData The event data containing the trigger and the popover content
  * @returns {void}
  */
	onPopoverCloseCallback: function onPopoverCloseCallback(eventData) {
		eventData.$trigger.removeClass(this._stateClasses.open);
	}
});